import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { closeAllModals } from 'reducers/modalReducer';
import { JBDialogTitle, JBIcon } from '@bjb-gcrm/gcrm-frontend-components';

interface GenericModalProps {
  content: React.ReactNode;
}

const GenericModal = ({ content }: GenericModalProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Dialog open={true} fullWidth={true} maxWidth="xl" aria-labelledby="dialog-title" PaperProps={{ square: true }}>
      <JBDialogTitle
        title={t('revisionHistory.title')}
        iconBeforeTitle={<JBIcon iconName="changeHistory" size="xl" />}
        handleClose={() => dispatch(closeAllModals())}
        customId="revision-history"
      />
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => dispatch(closeAllModals())}
          id="revision-history-ok-button"
          data-testid="revision-history-ok-button"
          sx={{ m: 0 }}
        >
          {t('revisionHistory.table.close', 'Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenericModal;
